import React, { useCallback, useEffect } from 'react';
import { Button, Form, Modal } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { hideApprovedInfoDialog, setNeverShowApprovedInfoDialog } from '../../../slices/client-voices-slice';
import { AcceptPositionButton } from './AcceptPositionButton';

export function ApprovedInfoDialog() {
    const { approved, showApprovedInfoDialog, neverShowApprovedInfoDialog } = useSelector(state => state.clientVoices);
    const dispatch = useDispatch();
    const handleClose = useCallback(() => {
        dispatch(hideApprovedInfoDialog());
    }, [dispatch]);
    const handleNeverShowClick = useCallback(() => {
        dispatch(setNeverShowApprovedInfoDialog(!neverShowApprovedInfoDialog));
    }, [dispatch, neverShowApprovedInfoDialog]);
    useEffect(() => {
        if (approved) {
            dispatch(hideApprovedInfoDialog());
        }
    }, [approved, dispatch]);
    return (
        <Modal show={showApprovedInfoDialog} backdrop="static" keyboard={false} onHide={handleClose}>
            <Modal.Header closeButton>
                <Modal.Title>Подтвердите свое местоположение</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <p>
                    Подтвердите, что вы на фестивале. Для этого нам потребуется доступ к вашему местуположению.
                    Подтвердить можно и позднее кнопкой &quot;Подтвердить&quot; над программой. Лайкать можно и без
                    подтверждения, но в этом случае ваш голос не будет учтен при подсчете.
                </p>
                <div className="text-right small">
                    <Form.Check
                        type="checkbox"
                        label="Больше не показывать этот диалог"
                        value={neverShowApprovedInfoDialog}
                        onChange={handleNeverShowClick}
                        id="neverShowApprovedInfoDialogCheckbox"
                    />
                </div>
            </Modal.Body>
            <Modal.Footer>
                <AcceptPositionButton shortForm />
                <Button variant="secondary" onClick={handleClose}>
                    Закрыть
                </Button>
            </Modal.Footer>
        </Modal>
    );
}
